import React, { useEffect, useState } from "react"
import { useDrag } from "muuri-react"
import _ from 'lodash'
import { getTimestamp, getTimestamp3 } from '../utils'

export const Calls = ({ color, width, height, title, calls }) => {

console.log('calls', calls)  

//const [callers, setCallers] = useState()

  const isDragging = useDrag()
  const shadow = isDragging ? "shadow" : ""
  
  const _telegram  = JSON.parse(localStorage.getItem("telegram5")) !== null 
                   ? JSON.parse(localStorage.getItem("telegram5")) 
                   : []


  if (_telegram.length > 0 && calls !== undefined) {

    const filterArr = []

    _telegram.map((tweetSetting)=>{
      for (let tw of calls) {
        if (tw.name === tweetSetting.name && tweetSetting.active) {
          filterArr.push(tw)
        }
      }
    })

    filterArr.sort((a, b) => b.timestamp - a.timestamp);

    // calls = filterArr

  }
                  

let data = { posts: [] }

  return (
   

    <div className={`item h${height} w${width} ${color} ${shadow}`}>
      <div className="handle">
        <span className="header">Telegram</span> 
        <img src="./dragIcon.png" className="dragIcon" />
      </div>
      <div className="item-content">
        
        {
          !_.isNil(calls) && calls.length > 0
          ? calls.map(call =>
            <ul key={call.id} style={{marginBottom: '20px'}}>
                <li><span style={{color: 'rgb(0, 218, 255)'}}>{call.name === 'overdose' ? 'Overdose' : call.name === 'watisdes' ? 'Wat is Des' : call.name}</span> <span className="ts">{getTimestamp3(call.created_at)}</span></li>
                <li><p style={{color: '#7c83f7'}}>{call.msg}</p></li>
              </ul>)
            : 'Loading Calls'
        }
      </div>
    </div>
 
  )
}
